module.exports = __webpack_public_path__ + "static/cart-icon-d90b1b0c8af6ff14c55246d4b04c2d01.png";